import {reportError} from "@finance/shared/observability";
import {initializeObservability} from "@/services/observability";
import {captureLinkHandoff} from "@/services/link_handoff";

// A plugin link's one-time code leaves the address bar before anything records the URL.
captureLinkHandoff();
initializeObservability();
// Start monitoring before application modules, router, and native bridges load.
void import("./main").catch((error: unknown) => reportError(error, "frontend.startup"));
